<template>
  <div class="bg-white">
    <img :src="src" loading="lazy" alt="Map">
  </div>
</template>

<script>
import merge from 'lodash/merge'
import { viewport } from '@placemarkio/geo-viewport'
import venueTypes from '~/config/venue-types.json'

export default {
  props: {
    destination: { type: Object, required: true },
    venues: { type: Array, required: true },
    venue: { type: Object, required: true },
  },

  computed: {
    bounds () {
      return [
        Math.min(...this.allVenues.map(v => v.longitude)),
        Math.min(...this.allVenues.map(v => v.latitude)),
        Math.max(...this.allVenues.map(v => v.longitude)),
        Math.max(...this.allVenues.map(v => v.latitude)),
      ]
    },

    src () {
      const size = [879, 491]
      const vp = viewport(this.bounds, size, {
        minzoom: undefined,
        maxzoom: undefined,
        tileSize: 512,
        allowFloat: true,
      })
      const markers = this.allVenues.map((v) => {
        let marker
        const venueType = venueTypes.find(vt => vt.id === v.venue_type_id)
        if (v.mainVenue) {
          marker = this.markerUrl()
        } else {
          marker = this.markerUrl(venueType.permalink)
        }
        return `url-${marker}(${v.longitude},${v.latitude})`
      })

      return `https://api.mapbox.com/styles/v1/tripexpertweb/ckcdpjifn06ru1impw321xsqi/static/${markers.join(',')}/${vp.center.join(',')},${vp.zoom - (vp.zoom / 100)}/${size.join('x')}@2x?access_token=${process.env.MAPBOX_API_TOKEN}`
    },

    allVenues () {
      const venue = merge({}, this.venue, { mainVenue: true })
      const venues = this.venues.slice()
      venues.push(venue)
      return venues
    },
  },

  methods: {
    markerUrl (type = '') {
      if (type) { type = `-${type}` }
      return encodeURIComponent(`https://www.tripexpert.com/images/marker${type}-fade@2x.png`)
    },
  },
}
</script>
